<template>
  <div>
    <page-header title="Incident And Request" breadcrumb="Dashboard > Booking & Shipments > Incident And Request"
      :back="{ name: 'IncidentAndRequest' }" />
    <div class="card">
      <div class="flex justify-between flex-wrap">
        <div class="flex gap-4 flex-wrap">
          <qrcode />
          <div class="flex flex-col w-full md:w-auto">
            <p>
              <span class="font-bold">{{ incident.fleetType || "" }} breakdown</span> by
              <span class="font-bold">{{ incident.driver || "" }}</span>
            </p>
            <p class="opacity-50">created {{ formatTime(incident.createdAt) }}</p>
            <p class="my-1">Status: <span class="text-green">{{ incident.status || ""}}</span></p>
            <p>Shipping Ref: {{ incident.shippingDispatchRef || "" }}</p>
          </div>
        </div>
        <div class="flex flex-col md:p-3 w-full md:w-auto mt-3 md:mt-0" style="background: #f9fafc">
          <p>
            <span class="inline-block w-40">Request Category:</span>
            <span>{{ incident.requestCategory || "N/A" }}</span>
          </p>
          <p>
            <span class="inline-block w-40">Severity:</span> <span>{{  incident.severity || "N/A" }}</span>
          </p>
          <p>
            <span class="inline-block w-40">Address:</span>
            <span>{{ incident.address || "N/A" }}</span>
          </p>
        </div>
      </div>
      <hr class="my-8" />
      <h3 class="font-bold text-lg">Incident Detail</h3>
      <p class="my-7">
       {{ incident.incidentDetail || "" }}
      </p>
      <hr />
      <h3 class="font-bold text-lg my-8 mb-3">Attachments</h3>
      <div class="flex justify-between items-center p-2 rounded-lg" style="background: #f9fafc">
        <div class="flex gap-4 p-2">
          <div @click="showImageSlides = true" v-for="(value, index) in (incident.attachments || [])" :key="index">
            <img src="@/assets/images/icons/image-placeholder.svg" alt="Attach Image" />
            image {{ index }}
          </div>
        </div>
        <div class="flex gap-2 items-center" v-if="(incident.attachments || []).length > 0">
          <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.87695 10.4102C7.89157 10.4288 7.91024 10.4439 7.93156 10.4543C7.95288 10.4647 7.97629 10.4701 8 10.4701C8.02371 10.4701 8.04712 10.4647 8.06844 10.4543C8.08976 10.4439 8.10843 10.4288 8.12305 10.4102L10.3105 7.64258C10.3906 7.54102 10.3184 7.39062 10.1875 7.39062H8.74023V0.78125C8.74023 0.695312 8.66992 0.625 8.58398 0.625H7.41211C7.32617 0.625 7.25586 0.695312 7.25586 0.78125V7.38867H5.8125C5.68164 7.38867 5.60938 7.53906 5.68945 7.64062L7.87695 10.4102ZM15.1484 9.72656H13.9766C13.8906 9.72656 13.8203 9.79688 13.8203 9.88281V12.8906H2.17969V9.88281C2.17969 9.79688 2.10938 9.72656 2.02344 9.72656H0.851562C0.765625 9.72656 0.695312 9.79688 0.695312 9.88281V13.75C0.695312 14.0957 0.974609 14.375 1.32031 14.375H14.6797C15.0254 14.375 15.3047 14.0957 15.3047 13.75V9.88281C15.3047 9.79688 15.2344 9.72656 15.1484 9.72656Z"
              fill="#1831CC" />
          </svg>

          Download all attachments
        </div>
        <div v-if="(incident.attachments || []).length < 1" class="flex w-full justify-start">
              <span class="opacity-50">No Attachment</span>
        </div>
      </div>
      <hr class="my-8" />
      <h3 class="font-bold">Comments</h3>
      <p class="my-4 mb-3">Write a Comment</p>
      <textarea class="mt-0 p-4 text_area mb-4 rounded-md resize-none" name="" id="" cols="30" rows="5"
        placeholder="Thanks  James Obinna. We will provide a vehicle close by as soon as possible."></textarea>
      <div class="flex justify-end mt-0">
        <base-button class="px-10" text="Send" />
      </div>
      <div class="flex justify-between my-4">
        <div class="flex flex-col">
          <div class="flex gap-2 items-center">
             <img src="./icons/person_placeholder.svg"/>
            <span class="font-bold">Jane adekole</span>
            <span class="text-gray-400">12/02/2021, Added 20 minutes ago.</span>
          </div>
          <p class="left_mar">Cmentdjn cdj</p>
        </div>
        <div class="flex gap-4">
          <div class="flex gap-2 items-center">
            <img class="w-5" src="@/assets/images/icons/reply-icon.svg" alt="Attach Image" />
            <span class="">Reply</span>
          </div>
          <div class="flex gap-2 items-center">
            <img src="@/assets/images/icons/edit.svg" alt="Attach Image" class="w-4" />
            <span class="">Edit</span>
          </div>
        </div>
      </div>
    </div>
    <image-slide-show :show-modal="showImageSlides" @close-modal="showImageSlides = false" />
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import ImageSlideShow from "@/components/3pl/IncidentAndRequest/Modals/ImageSlideShow";
import moment from "moment";

export default {
  components: {
    PageHeader,
    ImageSlideShow,
  },
  mounted() {
       this.getIncidentById()
  },
  methods: {
    formatTime(date){
       return  moment(date).format("Do MMMM, YYYY")
    },
    async getIncidentById(){
         try {
          const response = await this.$_incedentById(this.$route.params.id);
          console.log(response?.data?.data.incidentReport);
          this.incident = response?.data?.data?.incidentReport
         } catch (error) {
            //
         }
    }
  },
  data() {
    return {
      showImageSlides: false,
      incident: {}
    };
  },
};
</script>

<style lang="scss" scoped>
.text_area {
  @apply bg-[#f9fafc]
}

.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;

  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}
 .left_mar{
  @apply ml-12
 }
</style>